import React, { useRef } from 'react';
import useGsapReveal from '../hooks/useGsapReveal';

/** Wraps a group of sections that are not a page component (e.g. the home route) in one reveal scope. */
export default function RevealScope({ children, className }) {
  const ref = useRef(null);
  useGsapReveal(ref);
  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  );
}
